<router-outlet></router-outlet>

<ng-template #lockExitModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Confirmation</h5>
    </div>

    <div class="modal-body">
        Étes-vous sûr de vouloir quitter ?
        <br>
        La page sera débloquée.
    </div>

    <div class="modal-footer">
        <button class="btn btn-outline-secondary" (click)="modal.dismiss()">
            {{ 'actions.stay' | translate }}
        </button>

        <button class="btn btn-danger" (click)="modal.close()">
            {{ 'actions.exit' | translate }}
        </button>
    </div>
</ng-template>

<ng-template #activeModificationExitModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Confirmation</h5>
    </div>

    <div class="modal-body">
        Vous avez des modifications non sauvegardées.
        <br>
        Étes-vous sûr de vouloir quitter ?
    </div>

    <div class="modal-footer">
        <button class="btn btn-outline-secondary" (click)="modal.dismiss()">
            {{ 'actions.stay' | translate }}
        </button>

        <button class="btn btn-danger" (click)="modal.close()">
            {{ 'actions.exit' | translate }}
        </button>
    </div>
</ng-template>
